import instance from "./api";
import EndPoints from "./api-endpoints";

const ok = (r: any) => r;
const err = (e: any) => e.response;

// ---- registers ----
const getInvoices = async (page = 0, size = 100) =>
  instance.get(EndPoints.getInvoices, { params: { page, size } }).then(ok).catch(err);

const getInvoiceDetails = async (invoiceNumber: string) =>
  instance.get(`${EndPoints.getInvoiceDetails}/${invoiceNumber}`).then(ok).catch(err);

const getQuotations = async (page = 0, size = 100) =>
  instance.get(EndPoints.getAllQuotations, { params: { page, size } }).then(ok).catch(err);

const getQuotationDetails = async (quotationNumber: string) =>
  instance.get(`${EndPoints.quotations}/${quotationNumber}`).then(ok).catch(err);

// ---- quotation lifecycle ----
const offerQuotation = async (quotationNumber: string, branchId?: string) =>
  instance.post(`${EndPoints.quotations}/${quotationNumber}/offer`, branchId ? { branchId } : {}).then(ok).catch(err);

const acceptQuotation = async (quotationNumber: string, acceptedByName: string) =>
  instance.post(`${EndPoints.quotations}/${quotationNumber}/accept`, { acceptedByName }).then(ok).catch(err);

const rejectQuotation = async (quotationNumber: string, reason?: string) =>
  instance.post(`${EndPoints.quotations}/${quotationNumber}/reject`, { reason }).then(ok).catch(err);

// ---- invoice ----
const issueInvoice = async (quotationNumber: string, dueDate?: string, notes?: string) =>
  instance.post(EndPoints.issueInvoice, { quotationNumber, dueDate, notes }).then(ok).catch(err);

const getInvoicePdfUrl = (invoiceNumber: string) =>
  `${EndPoints.invoicesBase}/${invoiceNumber}/pdf`;

const downloadInvoicePdf = async (invoiceNumber: string) =>
  instance
    .get(getInvoicePdfUrl(invoiceNumber), { responseType: "blob" })
    .then(ok)
    .catch(err);

const runOverdueCheck = async () =>
  instance.post(`${EndPoints.invoicesBase}/overdue-check`).then(ok).catch(err);

// ---- payments (proof of payment + confirmation) ----
const getInvoicePayments = async (invoiceNumber: string) =>
  instance.get(`${EndPoints.invoicesBase}/${invoiceNumber}/payments`).then(ok).catch(err);

const recordPayment = async (
  invoiceNumber: string,
  payment: { amount: number; paidDate?: string; reference?: string; cashAccountId?: string; notes?: string },
  proofOfPayment?: File | null,
) => {
  const form = new FormData();
  form.append(
    "payment",
    new Blob([JSON.stringify(payment)], { type: "application/json" }),
  );
  if (proofOfPayment) form.append("proofOfPayment", proofOfPayment);
  return instance
    .post(`${EndPoints.invoicesBase}/${invoiceNumber}/payments`, form)
    .then(ok)
    .catch(err);
};

const confirmPayment = async (paymentId: string) =>
  instance.post(`${EndPoints.paymentsBase}/${paymentId}/confirm`).then(ok).catch(err);

const rejectPayment = async (paymentId: string, reason?: string) =>
  instance
    .post(`${EndPoints.paymentsBase}/${paymentId}/reject`, null, { params: reason ? { reason } : {} })
    .then(ok)
    .catch(err);

// ---- payment gate + Acknowledgement of Debt (SOP §12.1, FR-094/095) ----
const getCasePaymentStatus = async (caseNumber: string) =>
  instance.get(`${EndPoints.casesBase}/${caseNumber}/payment-status`).then(ok).catch(err);

const requestAod = async (payload: {
  caseNumber: string;
  invoiceNumber?: string;
  amount?: number;
  reason: string;
}) => instance.post(EndPoints.aods, payload).then(ok).catch(err);

const getAodsForCase = async (caseNumber: string) =>
  instance.get(`${EndPoints.casesBase}/${caseNumber}/aods`).then(ok).catch(err);

const getPendingAods = async () =>
  instance.get(`${EndPoints.aods}/pending`).then(ok).catch(err);

const approveAodAsGcoo = async (aodNumber: string) =>
  instance.post(`${EndPoints.aods}/${aodNumber}/approve/gcoo`).then(ok).catch(err);

const approveAodAsGceo = async (aodNumber: string) =>
  instance.post(`${EndPoints.aods}/${aodNumber}/approve/gceo`).then(ok).catch(err);

const rejectAod = async (aodNumber: string, reason: string) =>
  instance.post(`${EndPoints.aods}/${aodNumber}/reject`, null, { params: { reason } }).then(ok).catch(err);

export {
  getCasePaymentStatus,
  requestAod,
  getAodsForCase,
  getPendingAods,
  approveAodAsGcoo,
  approveAodAsGceo,
  rejectAod,
  getInvoices,
  getInvoiceDetails,
  getQuotations,
  getQuotationDetails,
  offerQuotation,
  acceptQuotation,
  rejectQuotation,
  issueInvoice,
  getInvoicePdfUrl,
  downloadInvoicePdf,
  runOverdueCheck,
  getInvoicePayments,
  recordPayment,
  confirmPayment,
  rejectPayment,
};
